import React from "react";
import { createStripeAccountLink } from "../../../../services/StripeServices";
import globalStyles from "../../../../styles/globalStyles.module.css";
import { useTranslation } from "react-i18next";

const AccountLink: React.FC = () => {
  const { t } = useTranslation();

  const handleCreateStripeAccountLink = async () => {
    const json = await createStripeAccountLink();
    const { url } = json;
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <button
        onClick={handleCreateStripeAccountLink}
        className={globalStyles.button}
      >
        {t("stripe.addInformation")}
      </button>
    </>
  );
};

export default AccountLink;
